import { Box, styled, Typography } from '@mui/material';

export const DragBodyContainer = styled(Box)`
  box-sizing: border-box;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%2379747e' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='2' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0px;
  gap: 8px;

  width: 100%;
  height: 100%;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

export const StyledTypography = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-items: center;

  color: #6b7280;

  flex: none;
  order: 1;
  flex-grow: 0;
`;
